/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDemandRequest } from '../models/CreateDemandRequest';
import type { DemandResponse } from '../models/DemandResponse';
import type { PageableDemandResponse } from '../models/PageableDemandResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DemandApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create Demand
   * @param requestBody
   * @returns any Create Demand
   * @throws ApiError
   */
  public createDemand(
    requestBody?: CreateDemandRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/demands',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Demand
   * @param id
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableDemandResponse Get Demand
   * @throws ApiError
   */
  public getDemands(
    id: string,
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableDemandResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/demands/{id}',
      path: {
        'id': id,
      },
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update
   * @param id
   * @param requestBody
   * @returns DemandResponse Update
   * @throws ApiError
   */
  public updateDemand(
    id: string,
    requestBody?: CreateDemandRequest,
  ): CancelablePromise<DemandResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/demands/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * close
   * @param id
   * @returns any Closed
   * @throws ApiError
   */
  public close(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/demands/close/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
